import { gql } from '@apollo/client'
import { AddressFragment } from './address.fragments'

export const FirmProfileInfoFragments = {
    firmProfileInfoFragment: gql`
        fragment firmProfileInfoFragment on FirmProfileInfo {
            address {
                ...addressFragment
            }
            contactInfo {
                email
                firstName
                lastName
            }
            publicPhone
            website
        }
        ${AddressFragment}
    `,
    firmProfileInfoPageFragment: gql`
        fragment firmProfileInfoPageFragment on FirmProfileInfo {
            address {
                ...addressFragment
            }
            publicPhone
            bannerUrl
            logoUrl
            website
            whoWeAre
        }
        ${AddressFragment}
    `,
}
